import React from 'react';
import '../less/index.less';
import DownloadApp from '../../../../Cards/views/downloadApp.c';
import Order from '../../../../Cards/views/orderAction';
import Banner from "../../../../../auxiliary-components/shared/Banner";
import order_profit_card from "../img/order_profit_card.png";
import TabsNew from "../../../../../auxiliary-components/shared/TabsNew";
import UsageBlock from "../../../../../auxiliary-components/shared/UsageBlock";
import TextAboveFooter from "../../../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import usage_block_2_data from '../enums/usage_block_2_data.json';
import usage_block_data from '../enums/usage_block_data.json';
import HowToBlock from "../../../../../auxiliary-components/shared/HowToBlock";
import how_to_installment_1 from "../img/how_to_installment_1.png";
import how_to_installment_2 from "../img/how_to_installment_2.png";
import how_to_installment_3 from "../img/how_to_installment_3.png";
import how_to_installment_4 from "../img/how_to_installment_4.png";
import FilesForDownload from "../../../../../auxiliary-components/shared/FilesForDownload/views/file.c";
import InstallmentCalc from "../components/installmentCalc";
import scrollToOrder from 'utils/scrollToOrder';
import QuestionsBlock from "../../../../../auxiliary-components/shared/QuestionsBlock";
import questions from "../enums/questions.json";

export default function template() {
    const isMobile = this.isViewportMobile(),
      {viewport} = this.props,
      modes = [ {mode: 'info', title: 'GREEN_CARD_NAV_TITLE_1'},
          {mode: 'repayment', title: 'CREDIT_QUICK_CASH_NAV_TITLE_2'},
          {mode: 'questions', title: 'CREDIT_QUICK_CASH_NAV_TITLE_3'}],
      page = 'profit-card',
      howToItems_installment = [
        { img: how_to_installment_1, title: 'PROFIT_CARD_HOW_TO_TITLE_1', text: 'PROFIT_INSTALLMENT_HOW_TO_INSTALLMENT_TEXT_1' },
        { img: how_to_installment_2, title: 'PROFIT_CARD_HOW_TO_TITLE_2', text: 'PROFIT_INSTALLMENT_HOW_TO_INSTALLMENT_TEXT_2' },
        { img: how_to_installment_3, title: 'PROFIT_CARD_HOW_TO_TITLE_3', text: 'PROFIT_INSTALLMENT_HOW_TO_INSTALLMENT_TEXT_3' },
        { img: how_to_installment_4, title: 'PROFIT_CARD_HOW_TO_TITLE_4', text: 'PROFIT_INSTALLMENT_HOW_TO_INSTALLMENT_TEXT_4' }
      ],


        model = this.getModel();

    if (model.setRealRate) {
        model.setRealRate(this.l10n('CALCULATOR_CREDIT_CARDS_REAL_YEAR_RATE_1'));
    }

    const orderCards = (
        <div className="card-order-wrapper" id='order'>
            <div className="left-side">
                <div className="title">{this.l10n('GC_WANT_TO_ORDER')}</div>
                <div className="sub-title">{this.l10n('GC_WANT_TO_ORDER_SUBTITLE')}</div>
                <div className="card-order">
                    <div className="order-wrapper green-card">
                        <Order
                          {...this.props}
                          row={!this.isViewportMobile()}
                          utmParams={this.utmParams}
                          type="vygoda"
                        />
                    </div>
                </div>
            </div>
            <img className="order-img" alt=" " src={order_profit_card}></img>
        </div>
    ),
      installmentCalc = (
        <InstallmentCalc></InstallmentCalc>
      ),
      isUtm = this.props.location.search.indexOf('utm_') !== -1,
    app = isMobile && isUtm ?
      (
        <div className="content">
          {orderCards}
        </div>
      )
      :
      (
        <div className="download-app-wrapper" id='order'>
          <DownloadApp {...this.props} />
        </div>
      );
    return (
        <div className="profit-installment-block">
            <Banner
              img={''}
              text={'INSTALLMENT_PROFIT_SUBTITLE'}
              textMob={'INSTALLMENT_PROFIT_SUBTITLE'}
              title={'INSTALLMENT_PROFIT_TITLE'}
              toggleModal={()=> {this.setState({
                mode: "info"
              }, scrollToOrder)}}
              btnText={'CARD_PROFIT_BTN'}
              page={'profit-installment'}
              isMobile={isMobile}>
            </Banner>
            <TabsNew modes={modes}
                     isMobile={isMobile}
                     page={'quick-cash'}
                     toggle={this.toggleMode}
                     mode={this.state.mode}>
                <div className="wrapper" type={modes[0].mode}>
                  <div className='content'>
                    <UsageBlock isMobile={isMobile} page={'profit-second'} data={usage_block_2_data} className="col-3-row-1"/>
                  </div>
                  {installmentCalc}
                  <div class='anchorlink' id='order-card'></div>
                  {app}
                  <div className="content">
                    <div className="how-to-block-wrapper">
                      <div className="block-title">{this.l10n("PROFIT_CARD_INSTALLMENT_HOW_TO_TITLE")}</div>
                      <HowToBlock data={howToItems_installment} isMobile={isMobile} page={'green-card'}></HowToBlock>
                    </div>
                  </div>
                  <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>
                </div>
                <div className="wrapper" type={modes[1].mode}>
                  <div className='content'>
                    <div className='repayment-block'>
                      <div className="block-title" dangerouslySetInnerHTML={{__html: this.l10n("PROFIT_INSTALLMENT_INSTALLMENT_HOW_TO_TITLE")}}></div>
                      <ul className='special-list'>
                        <li className='special-list-item' dangerouslySetInnerHTML={{__html: this.l10n('PROFIT_INSTALLMENT_INSTALLMENT_HOW_TO_TEXT_1')}}></li>
                        <li className='special-list-item' dangerouslySetInnerHTML={{__html: this.l10n('PROFIT_INSTALLMENT_INSTALLMENT_HOW_TO_TEXT_2')}}></li>
                      </ul>
                    </div>
                    <UsageBlock isMobile={isMobile} page={'profit-second'} data={usage_block_data} className="col-3-row-1"/>
                  </div>
                </div>
                <div className="wrapper" type={modes[2].mode}>
                  <div className='content'>
                    <QuestionsBlock isMobile={isMobile} page={page} data={questions} />
                  </div>
                </div>
            </TabsNew>

            <div className={`disclaimer-wrapper`}>
                <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')} isMobile={isMobile}></TextAboveFooter>
            </div>
        </div>

    );
}
